import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme";
import animatePlugin from "tailwindcss-animate";

export default {
  content: ["./src/**/*.{js,jsx,ts,tsx,svg}"],
  theme: {
    screens: {
      sm: "640px",
      md: "768px",
      lg: "992px",
      xl: "1200px",
      xxl: "1400px",
    },
    container: {
      center: true,
      padding: {
        DEFAULT: "1rem",
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "992px",
        xl: "1200px",
        xxl: "1400px",
      },
    },
    extend: {
      colors: {
        primary: {
          DEFAULT: "#F97C50",
          50: "#FFFFFF",
          100: "#FEF2EE",
          200: "#FDCBB9",
          300: "#FBB096",
          400: "#FA9673",
          500: "#F97C50",
          600: "#CE6540",
          700: "#A24E30",
          800: "#773721",
          900: "#4B2011",
          950: "#200901",
        },
        secondary: {
          DEFAULT: "#8DC6BF",
          50: "#FFFFFF",
          100: "#F4F9F9",
          200: "#D1E8E5",
          300: "#BBDDD9",
          400: "#A4D1CC",
          500: "#8DC6BF",
          600: "#74A49E",
          700: "#5A827D",
          800: "#41615D",
          900: "#273F3C",
          950: "#0E1D1B",
        },
        tertiary: {
          DEFAULT: "#FCBC65",
          50: "#FFFFFF",
          100: "#FFF8F0",
          200: "#FEE4C1",
          300: "#FDD7A3",
          400: "#FDC984",
          500: "#FCBC65",
          600: "#D59D51",
          700: "#AE7E3D",
          800: "#865F29",
          900: "#5F4015",
          950: "#382101",
        },
        black: {
          DEFAULT: "#333",
        },
      },
      fontFamily: {
        sans: ["Poppins", ...defaultTheme.fontFamily.sans],
      },
    },
  },
  plugins: [animatePlugin],
  safelist: [
    "cursor-progress",
    "cursor-not-allowed",
    "w-[30vw]",
    "max-w-[540px]",
    "flex-row-reverse",
  ],
} satisfies Config;
